import { contentMain, rightSidebarLayout } from "plos/src/layouts";
import { useTranslation } from "react-i18next";
import { HelmetHead } from "../HelmetHead";
import { prizesWrapper } from "./prizes.css";
import PrizesNav from "./PrizesNav";
import { GameweekTable, MonthTable } from "./WinnersTables";

const Winners = () => {
  const { t } = useTranslation("prizes");

  return (
    <>
      <HelmetHead
        title={t(
          "metadata.winners.title",
          "Prize Winners | Fantasy Premier League",
        )}
        description={t(
          "metadata.winners.description",
          "To view the Fantasy Premier League Gameweek and monthly prize winners, visit the official website of the Premier League.",
        )}
      />
      <div className={rightSidebarLayout}>
        <div className={contentMain}>
          <PrizesNav selected="winners" />
          <div className={prizesWrapper}>
            <GameweekTable />
            <MonthTable />
          </div>
        </div>
      </div>
    </>
  );
};

export default Winners;
